import React, {useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom"
import useFetch, {CachePolicies} from "use-http";

import SkeletonLinkFile from "./SkeletionLinkFile";
//@ts-ignore
import _ from "lodash";
import {checkEmpty, parseJwt} from "src/service/util.service";
import * as Auth from "../../../../service/auth.service";
import {APIChatEnpoint} from "src/service/chat.service";
import {FileContext} from "../../File.context";
import {mainState, nodataFile} from "src/props/util.props";
import InfiniteScroll from "react-infinite-scroll-component";
import styles from "./LinksContainer.module.scss";
import {useTranslation} from "react-i18next";
import galleryStyles from "./gallery.module.scss";
import classNames from "classnames";
import UILinkItem from "./UILinktem";
import NoData from "src/components/shared/NoDataDisplay/NoData";

const defaultLitmitOfset = 30;

const LinksContainer = (props: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [loadMore, setLoadMore] = useState(false);
  const [loading, setLoading] = useState(false);

  const [offsetFile, setOffsetFile]: any = useState(0);
  const [offsetFolder, setOffsetFolde]: any = useState(0);
  const fileContext: any = useContext(FileContext);
  const [links, setLinks]: any = useState([]);

  const getLinkData = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE + APIChatEnpoint.finfmessageslink,
    {
      // path: APIEnpoint.myApps,
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const getUserData = () => {
    let token = Auth.getToken();
    let userdata: any = null;
    if (!checkEmpty(token)) {
      userdata = parseJwt(token);
    }
    return userdata;
  };

  const fetchLinkData = async () => {
    // let time = new window.Date().toISOString();
    //let time = getLastTimeLink();
    let messageTime = getLastTimeLink(); //new window.Date().toISOString();
    const payload = {
      groupId: fileContext.groupId,
      userId: getUserData()?.userID,
      messageNumber: defaultLitmitOfset,
      messageTime: messageTime,
      type: "link",
    };

    if (offsetFile === 0) setLinks([]);
    await getLinkData.post(payload);
    if (offsetFile === 0) {
      setHasMore(true);
      setLoadMore(false);
    }
    setLinks((prev: any) => {
      if (links?.length === 0)
        return getLinkData.response?.data?.objData?.linkdatas;
      if (checkEmpty(prev)) prev = [];
      return [...prev, ...getLinkData.response?.data?.objData?.linkdatas];
    });
    if (getLinkData.response?.data?.objData?.total === 0) {
      setHasMore(false);
    }
    if (
      links?.length + defaultLitmitOfset >=
      getLinkData.response?.data?.objData?.total
    ) {
      setHasMore(false);
    }
  };
  const fetchLinkDataFirstTime = async () => {
    setLoading(true);
    await fetchLinkData();
    setLoading(false);
  };
  useEffect(() => {
    if (fileContext.groupId !== mainState.init) fetchLinkDataFirstTime();
  }, [fileContext.groupId, offsetFile, fileContext.mainTab]);

  useEffect(() => {
    setOffsetFile(0);
  }, [fileContext.mainTab]);

  const fetchNext = async () => {
    fetchNextLinks(
      fileContext,
      getLinkData.response?.data?.objData,
      setOffsetFile,
      defaultLitmitOfset,
      offsetFile
    );
  };

  function fetchNextLinks(
    fileContext: any,
    data: any,
    setOffsetFile: any,
    defaultLitmitOfset: any,
    offsetFile: any
  ) {
    console.log(" data : ", data);
    if (links?.length + defaultLitmitOfset >= data?.total) {
      setHasMore(false);
    }
    if (links?.length >= data?.total) {
      setHasMore(false);
    }
    if (links?.length < data?.total) {
      setLoadMore(true);
      setOffsetFile(offsetFile + defaultLitmitOfset);
    }
  }
  const getLastTimeLink = () => {
    try {
      let time = links[links.length - 1].messageTime;
      let date = new window.Date(time).getTime() - 1000;
      let finalDate = new window.Date(date).toISOString();
      return finalDate;
    } catch (e) {
      console.log(e);
      return new window.Date().toISOString();
    }
  };

  return (
    <>
      <InfiniteScroll
        dataLength={
          links !== null ? links?.length : 0
          // 100
        }
        next={fetchNext}
        hasMore={hasMore}
        scrollableTarget={"FileFoldersContainer"}
        loader={!hasMore ? null : <SkeletonLinkFile />}
        className={styles.customInfinitscroll}
      >
        <>
          {loading && !loadMore ? (
            <SkeletonLinkFile />
          ) : (
            <div
              key={"_item_link_inside"}
              className={galleryStyles.zard_gallery_container}
            >
              {
                //@ts-ignore
                links?.map((link, idx) => {
                  return (
                    <div
                      key={"_item_link_m" + link?.messageId}
                      className={classNames(galleryStyles.zard_gallery_tile)}
                    >
                      <div>
                        <UILinkItem link={link}></UILinkItem>
                      </div>
                    </div>
                  );
                })
              }
            </div>
          )}
          {!loading && links.length === 0 && (
            // <div className={styles.textEmpty}>{t("Empty")}</div>
            <NoData
              header={t(nodataFile.noDataHeaderTextLink)}
              detail={t(nodataFile.nodatatextLinkH) + ", " + t(nodataFile.nodatatextLinkL) + "."}
            />
          )}
        </>
      </InfiniteScroll>
    </>
  );
};

export default LinksContainer;
